import { Link } from "react-router-dom";
import { ArrowUpRight, Check, GraduationCap } from "lucide-react";
import { formationHref } from "@/components/site/FormationBox";
import { FORMATION_PATH, FORMATION_POINTS, formationPrice } from "@/lib/formation";
import { useLang } from "@/lib/i18n";

export const formationOrderHref = (src) => `${formationHref(src)}&to=essentiel`;

/** Prix de lancement (49 € puis 245 €) ; rien après la date. */
export function FormationPrice({ className = "", testid = "formation-price" }) {
  const p = formationPrice();
  if (!p) return null;
  return (
    <p data-testid={testid} className={`flex flex-wrap items-baseline gap-x-3 gap-y-1 ${className}`}>
      <span className="font-display text-4xl text-[var(--gold-soft)]">{p.now} €</span>
      <span className="text-sm text-[var(--parchment)]/85">pour le moment · passera à <b className="text-[var(--parchment)]">{p.after} €</b> le {p.until}</span>
    </p>
  );
}

/** Grand bloc d'accueil, juste sous le haut de page (français uniquement : formation en français). */
export function FormationHomeBlock() {
  const { lang } = useLang();
  if (lang === "en") return null;
  return (
    <section data-testid="formation-home-block" className="px-5 pt-12 md:px-10 md:pt-16">
      <div className="mx-auto grid max-w-6xl items-center gap-8 overflow-hidden rounded-sm border border-[var(--gold)]/40 bg-[#141013] p-6 md:grid-cols-[1.15fr_1fr] md:p-12">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.3em] text-[var(--gold-soft)]"><GraduationCap className="h-4 w-4" aria-hidden="true" /> Formation en ligne · Méthode Ozentya</p>
          <h2 className="mt-4 font-display text-4xl leading-[1.05] md:text-6xl">Avant le bon produit, <span className="italic text-[var(--gold-soft)]">il y a votre cheveu</span></h2>
          <p className="mt-4 max-w-xl text-base text-[var(--parchment)]/90">La formation de Pascal Chaubo, fondateur d'Ozentya, pour comprendre le cheveu afro et construire une routine vraiment adaptée : pour vos propres cheveux ou pour conseiller vos clientes.</p>
          <ul className="mt-5 space-y-2">
            {FORMATION_POINTS.map((t) => <li key={t} className="flex gap-2 text-sm text-[var(--parchment)]/90"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[var(--gold)]" aria-hidden="true" />{t}</li>)}
          </ul>
          <FormationPrice className="mt-6" testid="formation-home-price" />
          <div className="mt-7 flex flex-wrap items-center gap-4">
            <a href={formationOrderHref("accueil-bloc")} target="_blank" rel="noopener" data-testid="formation-home-cta" className="group inline-flex h-12 items-center gap-2 rounded-full bg-[var(--gold)] px-7 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ink)] transition-transform duration-300 hover:-translate-y-0.5">
              Je rejoins la formation <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
            <Link to={FORMATION_PATH} data-testid="formation-home-more" className="text-sm text-[var(--gold-soft)] underline underline-offset-4">Voir le programme</Link>
          </div>
        </div>
        <img src="/editorial/formation-email.jpg" alt="Peigne, sérum et carnet : apprendre à connaître son cheveu" className="w-full rounded-sm object-cover" loading="lazy" />
      </div>
    </section>
  );
}
